import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Loader2, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export default function BetaAgreementPage() {
  const navigate = useNavigate();
  const [agreement, setAgreement] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAgreement();
  }, []);

  const fetchAgreement = async () => {
    try {
      const res = await fetch(`${API}/api/beta-agreement`);
      if (res.ok) setAgreement(await res.json());
    } catch (err) {
      console.error('Failed to load agreement');
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="flex justify-center py-16">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!agreement) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-8 text-center text-muted-foreground">
        Failed to load agreement.
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 py-8" data-testid="beta-agreement-page">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate(-1)}
        className="mb-4"
        data-testid="back-btn"
      >
        <ArrowLeft className="h-4 w-4 mr-1" /> Back
      </Button>

      <Card>
        <CardHeader className="border-b">
          <CardTitle className="text-xl">{agreement.title}</CardTitle>
          <p className="text-sm text-muted-foreground">
            Version {agreement.version} — Effective {agreement.effective_date}
          </p>
        </CardHeader>
        <CardContent className="py-6 space-y-6">
          {/* Summary */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="text-sm font-semibold text-blue-900 mb-2">Summary of Key Points</h3>
            <ul className="space-y-1.5">
              {agreement.summary_points.map((point, i) => (
                <li key={i} className="text-sm text-blue-800 flex items-start gap-2">
                  <span className="text-blue-400 mt-0.5 shrink-0">*</span>
                  {point}
                </li>
              ))}
            </ul>
          </div>

          {/* Full sections */}
          {agreement.sections.map((section, i) => (
            <div key={i} className="space-y-2">
              <h3 className="text-base font-semibold text-gray-900">{section.title}</h3>
              <div className="text-sm text-gray-700 whitespace-pre-line leading-relaxed">
                {section.content}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
